import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import * as Actions from 'build-and-quote/actions/buildAndQuoteActions.js';

import 'build-and-quote/components/ShowroomHeader/showroomHeader.scss';

const ShowroomProgressBarStage = ({ actions, canModify, currentSection, stageId, stageName, visible, vehicleId }) => {
    const nextStageId = stageId + 1;
    let extraClass = '';

    if (currentSection > nextStageId && !vehicleId) {
        extraClass = 'validated';
    } else if (currentSection === nextStageId) {
        extraClass = 'selected';
    }

    const classes = `${extraClass} section-showroom-header__progressBar-stage`;

    const progressBarBlock = [
        <div key="1" className="progressBar-stage__active-effect" />,
        <div key="2" className="progressBar-stage__content">
            <icon className="icon-showroom icon-Crochet" />
            <span className="progressBar-stage__content--name">{LocaleService.t(`${stageName}`)}</span>
        </div>,
    ];

    return visible && canModify && !vehicleId ? (
        <li key={nextStageId} className={classes} onClick={() => actions.changeBuildAndQuoteSection(nextStageId)}>
            {progressBarBlock}
        </li>
    ) : (
        <li key={nextStageId} className={classes}>
            {progressBarBlock}
        </li>
    );
};

ShowroomProgressBarStage.defaultProps = {
    vehicleId: null,
};

ShowroomProgressBarStage.propTypes = {
    actions: PropTypes.shape({
        changeBuildAndQuoteSection: PropTypes.func.isRequired,
    }).isRequired,
    canModify: PropTypes.bool.isRequired,
    currentSection: PropTypes.number.isRequired,
    stageId: PropTypes.number.isRequired,
    stageName: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    vehicleId: PropTypes.number,
};

ShowroomProgressBarStage.displayName = 'ShowroomProgressBarStage';

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    null,
    mapDispatchToProps
)(ShowroomProgressBarStage);
